/** Stripe / Notion–style utility class bundles (Tailwind) — reuse for consistency */

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-pink-400 to-yellow-300 text-white font-semibold shadow-md hover:shadow-[0_0_30px_rgba(250,204,21,0.35)] hover:scale-[1.03] active:scale-[0.99] transition-all duration-300 disabled:opacity-50 disabled:pointer-events-none";

export const btnSecondary =
  "inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 transition-all duration-300";

/* export const btnWhatsApp =
  "inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-emerald-500 text-white font-semibold shadow-md hover:shadow-xl hover:bg-emerald-600 transition-all duration-300";*/

/** Primary action on dark / gradient backgrounds */
export const btnOnGradient =
  "inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white font-semibold text-rose-600 shadow-md hover:shadow-xl hover:scale-[1.02] transition-all duration-300";

/** Secondary outline on dark / gradient backgrounds */
export const btnOutlineOnGradient =
  "inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border-2 border-white/70 bg-white/10 font-semibold text-white backdrop-blur-sm hover:bg-white/20 transition-all duration-300";

export const btnEdit =
  "inline-flex items-center gap-2 px-4 py-2 rounded-full bg-rose-600 text-white hover:bg-rose-700 transition shadow";

export const btnDelete =
  "inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500 text-white hover:bg-red-600 transition shadow";

export const cardGlass =
  "bg-white/80 backdrop-blur-md rounded-2xl p-6 shadow-md hover:shadow-[0_0_30px_rgba(250,204,21,0.25)] transition-all duration-300";

export const inputField =
  "w-full px-4 py-3 rounded-xl border border-gray-200 text-slate-900 placeholder:text-slate-400 focus:ring-2 focus:ring-pink-400 focus:border-pink-300 outline-none transition-all duration-300";

export const textareaField = `${inputField} min-h-[120px] resize-y`;

export const pageShell =
  "min-h-[calc(100vh-5rem)] bg-[#f8fafc] py-10 md:py-14";

export const pageContainer = "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8";

export const pageTitle =
  "font-display text-center text-3xl font-semibold tracking-tight text-[#0f172a] md:text-4xl mb-3";

export const pageLead =
  "mx-auto mb-10 max-w-2xl text-center text-base text-slate-600 leading-relaxed";

export const emptyStateBox =
  "rounded-2xl border border-dashed border-slate-200 bg-white/70 py-16 px-6 text-center text-slate-500 shadow-sm";

export const badgeNew =
  "inline-flex items-center rounded-full bg-rose-100 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-rose-700 ring-1 ring-rose-200/80";

export const tabPill =
  "rounded-full px-4 py-2 text-sm font-medium transition-all duration-300";

export const tabPillActive =
  "bg-gradient-to-r from-pink-400 to-yellow-300 text-slate-900 shadow-md";

export const tabPillIdle =
  "bg-white/90 text-slate-600 ring-1 ring-slate-200 hover:bg-slate-50";

export const tableShell =
  "w-full overflow-hidden rounded-xl border border-slate-100 bg-white shadow-md";

export const tableHeadRow =
  "bg-slate-50 text-left text-xs font-semibold uppercase tracking-wide text-slate-500";

export const tableBodyRow =
  "border-t border-slate-100 transition-colors duration-300 hover:bg-slate-50/90";
